import { sendEmail } from 'backend/sendEmail.jsw';
import wixUsers from 'wix-users';
import wixCrm from 'wix-crm';
// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world

$w.onReady(function () {});

export function button19_click(event) {
    $w('#ErrorTxt').hide()
    if ($w('#input1').valid && $w('#input2').valid) {
		/*
    		wixUsers.emailUser('SGzUVew',"24cdbc16-826a-4804-950e-1c8f183821a7", {
          variables: {
            name: $w('#input1').value,
            phone: $w('#input2').value,
            email: $w('#input3').value
        }}).then((se)=>{console.log(se);}).catch((err)=>{console.log(err);})
        		 
				 */
				 if (sendEmail($w('#input1').value,$w('#input2').value,$w('#input3').value))
        		 {console.log("True");
             $w('#box1').expand()
             $w('#input1').collapse()()
             
             }
        
    } else { $w('#ErrorTxt').show() }

}